"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3152],{

/***/ 73152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17089);



var Limitations = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "limitations",
        className: "pt-[4rem]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "sticky text-[#4B4B4B] font-bold text-[21px] leading-[32px] top-0 py-[1.3rem] bg-[#F7F8F7] pl-[2rem]",
                children: "Limitations"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pl-[2rem]",
                children: src_constant__WEBPACK_IMPORTED_MODULE_2__/* .limitationsContents */ .M === null || src_constant__WEBPACK_IMPORTED_MODULE_2__/* .limitationsContents */ .M === void 0 ? void 0 : src_constant__WEBPACK_IMPORTED_MODULE_2__/* .limitationsContents.map */ .M.map(function(item, i) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "mb-[1em] text-[13px] leading-7 font-bold text-privacy",
                                children: item.articleTitle
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                children: (item === null || item === void 0 ? void 0 : (ref = item.lists) === null || ref === void 0 ? void 0 : ref.length) > 0 && (item === null || item === void 0 ? void 0 : (ref1 = item.lists) === null || ref1 === void 0 ? void 0 : ref1.map(function(option, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: "mb-[1em] text-[13px] leading-7 text-privacy font-medium",
                                        children: option
                                    }, "ajhsef_" + i);
                                }))
                            })
                        ]
                    }, "hrtasf_" + i);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Limitations);


/***/ })

}]);